export default __webpack_public_path__ + "static/sport-7ff1714b1dacfbedf2c86dce2aec2565.webp";